module.exports = __webpack_public_path__ + "img/category-page(right).a73fa0af.jpg";